import { Controller } from "@hotwired/stimulus"

let captchaPromise

function loadCaptcha() {
  if (window.grecaptcha?.render) return Promise.resolve(window.grecaptcha)
  if (!captchaPromise) {
    captchaPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      window.merrellEnquiryCaptchaReady = () => resolve(window.grecaptcha)
      script.src = "https://www.google.com/recaptcha/api.js?onload=merrellEnquiryCaptchaReady&render=explicit"
      script.async = true
      script.defer = true
      script.onerror = () => {
        script.remove()
        captchaPromise = undefined
        reject(new Error("Unable to load verification"))
      }
      document.head.appendChild(script)
    })
  }
  return captchaPromise
}

export default class extends Controller {
  static targets = ["captcha", "status", "submit"]
  static values = { siteKey: String }

  async connect() {
    this.reset()
    const generation = this.generation
    if (!this.siteKeyValue) {
      this.statusTarget.textContent = "The enquiry form is temporarily unavailable. Please try again later."
      return
    }
    try {
      const captcha = await loadCaptcha()
      if (!this.element.isConnected || generation !== this.generation) return
      this.widgetId = captcha.render(this.captchaTarget, {
        sitekey: this.siteKeyValue,
        callback: () => this.setVerified(true),
        "expired-callback": () => this.setVerified(false),
        "error-callback": () => this.setVerified(false, "Verification failed. Please try again.")
      })
      this.setVerified(false)
    } catch {
      if (generation !== this.generation) return
      this.setVerified(false, "Verification could not load. Please refresh the page and try again.")
    }
  }

  disconnect() {
    this.reset()
  }

  reset() {
    this.generation = (this.generation || 0) + 1
    if (this.widgetId !== undefined) window.grecaptcha?.reset(this.widgetId)
    this.widgetId = undefined
    this.captchaTarget.replaceChildren()
    this.verified = false
    this.submitTarget.disabled = true
    this.submitTarget.textContent = "Send enquiry"
    this.statusTarget.textContent = "Loading verification…"
  }

  setVerified(verified, message) {
    this.verified = verified
    this.submitTarget.disabled = !verified
    this.statusTarget.textContent = message || (verified ? "Verification complete." : "Please complete the verification above.")
  }

  submit(event) {
    if (!this.verified) {
      event.preventDefault()
      return
    }
    this.submitTarget.disabled = true
    this.submitTarget.textContent = "Sending…"
  }
}
